export type DateLike = Date | number | string | null | undefined;

export function formatDateTime(value: DateLike, fallback = '-'): string {
  if (value === null || value === undefined || value === '') return fallback;
  // A numeric timestamp of 0 / negative means "unset" everywhere in this app
  // (matches legacy `timeToStr`, which rendered these as '-'), NOT the 1970
  // epoch. Guard it here so every caller treats an empty timestamp the same.
  if (typeof value === 'number' && value <= 0) return fallback;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleString();
}
